import { contactCard } from './contactCard';

export const homeWarrantyContactCard = contactCard(
  'additionalContacts.homeWarranty',
  'homeWarranty',
);
